<template>
  <div class="result-model">
    <div class="result-model__wrapper">
      <block-heading :selector="`result-model`" :title="title" :text="text" :link="link"/>
      <div class="result-model__content">
        <div class="result-model__preview">
          <img :src="results.image" :alt="results.name"/>
        </div>
        <div class="result-model__results">
          <results-list :results="results.model"/>
        </div>
        <div v-if="secondText" class="result-model__second-text">{{secondText}}</div>
      </div>
      <slot name="otherContent"></slot>
    </div>
  </div>
</template>

<script>
import blockHeading from './blockHeading.vue';
import buttonTheme from './buttonTheme.vue';
import resultsList from './resultsList.vue';

export default {
  name: 'resultModel',
  props: {
    title: String,
    text: String,
    link: String,
    secondText: String,
  },
  components: {
    blockHeading,
    buttonTheme,
    resultsList,
  },
  computed: {
    results() {
      return this.$store.state.selectedResult;
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/setup.scss';

.result-model {
  &__wrapper {
    padding: 86px 6px 43px;

    @include up-tablet {
      margin: 0 auto;
      padding: 103px 0 84px;
      max-width: 543px;
    }

    @include up-desktop {
      padding: 111px 0;
      max-width: 543px;
    }
  }

  &__heading {
    margin-bottom: 9px;

    @include up-tablet {
      margin-bottom: 23px;
    }
  }

  &__text {
    margin-bottom: 25.82px;
    max-width: 260px;

    @include up-tablet {
      margin-bottom: 49.82px;
      max-width: 543px;
    }

    @include up-desktop {
      margin-bottom: 28.82px;
      max-width: 381px;
    }

    &.is-before-link {
      margin-bottom: 1em;
    }
  }

  &__link {
    margin-bottom: 25.82px;
    max-width: 260px;

    @include up-tablet {
      margin-bottom: 49.82px;
      max-width: 543px;
    }

    @include up-desktop {
      margin-bottom: 28.82px;
      max-width: 381px;
    }
  }

  &__content {
    @include up-tablet {
      display: grid;
      grid-template-columns: 47.51% 1fr;
      grid-column-gap: 27px;
      align-items: center;
    }
  }

  &__preview {
    margin: 0 auto 14.18px;
    width: 57.23vw;

    @include up-tablet {
      margin: 0;
      width: 100%;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  &__results {
    @include up-tablet {
      margin: 0;
      max-width: unset;
    }

    .results {
      &::after {
        background-color: $c-light-gray;
      }
    }
  }

  &__second-text {
    margin: 24.18px auto;
    width: 100%;
    max-width: 100%;
    text-align: center;
  }
}
</style>
